import React, { useState, useEffect, useRef } from 'react';
import { useForm } from 'react-hook-form';

import SUTextField from '../../Components/SUTextField';
import NodeEditorChrome from '../../Components/NodeEditorChrome';
import TriggerTypeField from '../../Components/TriggerTypeField';
import { InfoCallout } from '../../Components/NodeFormKit';
import useNodeEditor from '../../Components/useNodeEditor';

import styledComponent from 'styled-components';
import Select from 'react-select';

import { LuTags } from 'react-icons/lu';

const TAGS_NODE_COLOR = '#5BC0DE';

const Tags = ({
  selectedNode,
  handleSelectedNode,
  removeNode,
  nodes,
  edges,
  editFlow,
  updateBot,
  truncateText,
  customStyles,
  customStylesDark,
  isDark,
  listTags,
  watchSelectedNode,
  onMouseDown,
  isDragging,
  isExpanded,
  setIsExpanded,
}) => {
  const {
    watch,
    register,
    handleSubmit,
    formState: { errors },
    reset,
    setValue,
    getValues,
  } = useForm({
    user_response: null,
  });

  const { handleInputChange, loadData, saveNode, getIsDirty } = useNodeEditor({
    selectedNode,
    handleSelectedNode,
    nodes,
    edges,
    editFlow,
    updateBot,
    reset,
    getValues,
  });

  const [errorTag, setErrorTag] = useState(false);

  // ------> Selects, Radios, Checkbox
  const [loadingUpdate, setLoadingUpdate] = useState(false);

  // FUNCTIONS

  //# Function para manejar cambios de estados de campos

  //# Function para guardar los datos
  const saveData = (values) => {
    if (!selectedNode.data.tags.length) {
      setErrorTag(true);
      return;
    }

    setLoadingUpdate(true);

    const data = {
      title: values.title,
      user_response: values.user_response,
      trigger_type: selectedNode.data?.trigger_type || 'message',
    };

    saveNode(data, () => {
      setLoadingUpdate(false);
    });
  };

  //# Function para obtner data
  const getData = () => {
    let objectData = {
      title: selectedNode.data?.title ?? null,
      user_response: selectedNode.data?.user_response ?? null,
      trigger_type: selectedNode.data?.trigger_type ?? 'message',
    };
    loadData(objectData);
  };

  useEffect(() => {
    getData();
  }, [watchSelectedNode]);

  return (
    <NodeEditorChrome
      icon={LuTags}
      color={TAGS_NODE_COLOR}
      typeName="Etiquetas"
      title={truncateText(selectedNode.data.title)}
      onRemove={() => removeNode(selectedNode.id)}
      onMouseDown={onMouseDown}
      isDragging={isDragging}
      onClose={() => handleSelectedNode(null)}
      formId="tagsForm"
      saving={loadingUpdate}
      isDark={isDark}
      getIsDirty={getIsDirty}
      isExpanded={isExpanded}
      setIsExpanded={setIsExpanded}
    >
        <form id="tagsForm" onSubmit={handleSubmit(saveData)} style={{ width: '100%' }}>
          <div>
            <div className="col p-0">
              <SUTextField
                id="title"
                name="title"
                label="Título:"
                type="text"
                selectedNode={selectedNode}
                getValues={getValues}
                setValue={setValue}
                errors={errors}
                {...register('title', {
                  required: {
                    value: true,
                    message: 'Campo requerido.',
                  },
                  pattern: {
                    value: /\S+/,
                    message: 'No puede ser solo espacios en blanco',
                  },
                })}
              />
            </div>
            <div className="col p-0 mt-4">
              <SUTextField
                id="user_response"
                name="user_response"
                label="Respuesta del cliente:"
                hint="Lo que debe llegar para activar este nodo: el texto que escribe el cliente, el título de un botón, o * para cualquier respuesta. Para varios, separalos con  /  ."
                type="textArea"
                selectedNode={selectedNode}
                getValues={getValues}
                setValue={setValue}
                errors={errors}
                {...register('user_response', {
                  required: {
                    value: true,
                    message: 'Campo requerido.',
                  },
                  pattern: {
                    value: /\S+/,
                    message: 'No puede ser solo espacios en blanco',
                  },
                })}
              />

              <InfoCallout title="Importante:">
                Con el signo * el etiquetado funciona para cualquier respuesta
                que dé el cliente. Para varias respuestas, separalas con el
                formato Respuesta 1 / Respuesta 2 / Respuesta 3.
              </InfoCallout>
            </div>
            <div className="col p-0 mt-4">
              <TriggerTypeField
                value={selectedNode.data?.trigger_type}
                handleInputChange={handleInputChange}
                isDark={isDark}
                customStyles={customStyles}
                customStylesDark={customStylesDark}
              />
            </div>
            <div className="col p-0 mt-4">
              <label>Etiquetas: </label>
              <div className="su-control-group d-flex">
                <Select
                  styles={isDark == 'true' ? customStylesDark : customStyles}
                  className="form-control basic-multi-select"
                  isMulti
                  placeholder="Seleccione..."
                  value={selectedNode.data.tags}
                  name="tags"
                  onChange={(tag) => {
                    handleInputChange('tags', tag);
                    setErrorTag(false);
                  }}
                  options={listTags}
                  classNamePrefix="select"
                  noOptionsMessage={() => 'Sin opciones'}
                  getOptionLabel={(option) => (
                    <div className="option d-flex" style={{ fontSize: '15px' }}>
                      {option.title}
                    </div>
                  )}
                  getOptionValue={(option) => option.title}
                />
              </div>
            </div>
            {errorTag && <Alert>* Campo requerido</Alert>}
          </div>
        </form>
    </NodeEditorChrome>
  );
};

export default Tags;

const Alert = styledComponent.span`
  color: red;
  display: block;
  width: 100%;
  // width: 200px;
`;
